var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "forward"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1283_1162",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 16,
    height: 16,
    fill: "#196CCA"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1283_1162)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "forward_2",
    d: "M10.6668 11.333L9.71683 10.3997L12.7835 7.33301L9.71683 4.26634L10.6668 3.33301L14.6668 7.33301L10.6668 11.333ZM1.3335 12.6663V9.99967C1.3335 9.07745 1.6585 8.29134 2.3085 7.64134C2.9585 6.99134 3.74461 6.66634 4.66683 6.66634H8.7835L6.3835 4.26634L7.3335 3.33301L11.3335 7.33301L7.3335 11.333L6.3835 10.3997L8.7835 7.99967H4.66683C4.11127 7.99967 3.63905 8.19412 3.25016 8.58301C2.86127 8.9719 2.66683 9.44412 2.66683 9.99967V12.6663H1.3335Z",
    fill: "#196CCA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward);
export default __webpack_public_path__ + "static/media/forward.2e48a9cca0a7e52c42864029e176d746.svg";
export { ForwardRef as ReactComponent };